import { compact } from 'lodash-es';
import { serviceTemplateModel, serviceModel } from "../../models";
export class QboIntegrationPolicy {
  checkServiceMapping(_ref) {
    var _serviceTemplates$fin, _item$subItems$every, _item$subItems;
    let {
      item,
      serviceTemplates,
      accounting
    } = _ref;
    const serviceTemplate = item.serviceTemplateId ? serviceTemplates.find(st => st.id === item.serviceTemplateId) : undefined;
    const itemLinked = !serviceTemplate || serviceTemplateModel.integratedId({
      serviceTemplate,
      accounting
    });
    if (!itemLinked) return false;
    const bundleServices = item.serviceTemplateId ? (_serviceTemplates$fin = serviceTemplates.find(st => st.id === item.serviceTemplateId)) === null || _serviceTemplates$fin === void 0 || (_serviceTemplates$fin = _serviceTemplates$fin.bundle) === null || _serviceTemplates$fin === void 0 ? void 0 : _serviceTemplates$fin.services : undefined;
    return (_item$subItems$every = (_item$subItems = item.subItems) === null || _item$subItems === void 0 ? void 0 : _item$subItems.every(subItem => {
      var _subItem$origin;
      const subTemplate = (_subItem$origin = subItem.origin) !== null && _subItem$origin !== void 0 && _subItem$origin.serviceBundle.serviceTemplateId ? bundleServices === null || bundleServices === void 0 ? void 0 : bundleServices.find(bs => {
        var _subItem$origin2;
        return bs.id === ((_subItem$origin2 = subItem.origin) === null || _subItem$origin2 === void 0 ? void 0 : _subItem$origin2.serviceBundle.serviceTemplateId);
      }) : undefined;
      return !subTemplate || serviceTemplateModel.integratedId({
        serviceTemplate: subTemplate,
        accounting
      });
    })) !== null && _item$subItems$every !== void 0 ? _item$subItems$every : true;
  }
  checkContactsMapping(_ref2) {
    let {
      contacts,
      relationship,
      accounting
    } = _ref2;
    return contacts.some(c => c.id() === relationship.clientContactId && c.integratedId({
      accounting
    }));
  }
  getServiceTemplateIds(invoice) {
    const templateIds = [];
    invoice.items.forEach(item => {
      if (item.serviceTemplateId) {
        templateIds.push(item.serviceTemplateId);
      }
      if (item.subItems) {
        item.subItems.forEach(subItem => {
          var _subItem$origin3;
          if ((_subItem$origin3 = subItem.origin) !== null && _subItem$origin3 !== void 0 && _subItem$origin3.serviceBundle.serviceTemplateId) {
            templateIds.push(subItem.origin.serviceBundle.serviceTemplateId);
          }
        });
      }
    });
    return compact(templateIds);
  }
  getServiceTemplateIdsFromServices(services) {
    const templateIds = [];
    services.forEach(service => {
      var _service$bundle;
      templateIds.push(service.serviceTemplateId);
      if ((_service$bundle = service.bundle) !== null && _service$bundle !== void 0 && _service$bundle.services) {
        service.bundle.services.forEach(bundleService => {
          if (bundleService.serviceTemplateId) {
            templateIds.push(bundleService.serviceTemplateId);
          }
        });
      }
    });
    return compact(templateIds);
  }
  getUnintegratedServices(services, accounting) {
    return services.filter(service => {
      var _service$bundle2;
      const isServiceIntegrated = !!serviceModel.integratedId({
        service,
        accounting
      });
      if (!isServiceIntegrated) return true;
      if ((_service$bundle2 = service.bundle) !== null && _service$bundle2 !== void 0 && _service$bundle2.services) {
        return service.bundle.services.some(bundleService => {
          const bundleIntegratedId = bundleService.integrations.qboIntegratedId();
          return !bundleIntegratedId;
        });
      }
      return false;
    });
  }
}
export class XeroIntegrationPolicy {
  checkServiceMapping(_ref3) {
    let {
      item,
      serviceTemplates,
      accounting
    } = _ref3;
    const serviceTemplate = item.serviceTemplateId ? serviceTemplates.find(st => st.id === item.serviceTemplateId) : undefined;
    return !serviceTemplate || !!serviceTemplateModel.integratedId({
      serviceTemplate,
      accounting
    });
  }
  checkContactsMapping(_ref4) {
    let {
      contacts,
      relationship,
      accounting
    } = _ref4;
    return contacts.some(c => c.id() === relationship.clientContactId && c.integratedId({
      accounting
    }));
  }
  getServiceTemplateIds(invoice) {
    return compact(invoice.items.map(item => item.serviceTemplateId));
  }
  getServiceTemplateIdsFromServices(services) {
    return compact(services.map(service => service.serviceTemplateId));
  }
  getUnintegratedServices(services, accounting) {
    return services.filter(service => !serviceModel.integratedId({
      service,
      accounting
    }));
  }
}